import { legacyRedirect } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/analysis/deliverability')({
  beforeLoad: legacyRedirect('/workspaces/:workspaceId/analysis/deliverability'),
});
